import { render, staticRenderFns } from "./c-shared-configs.vue?vue&type=template&id=b392c59c"
import script from "./c-shared-configs.vue?vue&type=script&lang=js"
export * from "./c-shared-configs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b392c59c')) {
      api.createRecord('b392c59c', component.options)
    } else {
      api.reload('b392c59c', component.options)
    }
    module.hot.accept("./c-shared-configs.vue?vue&type=template&id=b392c59c", function () {
      api.rerender('b392c59c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/shared/c-shared-configs.vue"
export default component.exports